module.exports = __webpack_public_path__ + "aries-8f1aa6cca51a08065b7b.png";